"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { makeSubField } from '../data-field.mjs';
import DataBuilderFormNestedArrayItems from '../Nested/ArrayItems.mjs';
import classes from './ScalarArray.module.css.mjs';

function ScalarArrayFieldValue({ field, onChange }) {
  const currentValue = Array.isArray(field.value) ? field.value : [field.value];
  const dataBuilderField = makeSubField(field, {
    value: currentValue,
    level: 1
  });
  return /* @__PURE__ */ jsx("div", { className: classes.wrapper, children: /* @__PURE__ */ jsx(
    DataBuilderFormNestedArrayItems,
    {
      field: dataBuilderField,
      onChange
    }
  ) });
}

export { ScalarArrayFieldValue as default };
